import { CompetitionBadges } from '../../components/competition-badges';
import { SecretValue } from '~/components/SecretValue/SecretValue';
import { ButtonLink } from '~/components/ButtonLink/ButtonLink';
import { useAuthentication } from '~/hooks/useAuthentication';
import { useCollapse } from '~/hooks/useCollapse';
import { Table } from '~/components/Table/Table';
import { CompetitionDetail } from '~/apis/ssf';
import { Link } from '~/components/Link/Link';
import { Fragment } from 'react/jsx-runtime';
import { formatDate } from '~/utils/date';

interface Props {
  competition: CompetitionDetail;
}

export function CompetitionBasicInfo({ competition }: Props) {
  const { isOpen, toggle } = useCollapse();
  const { can } = useAuthentication();

  return (
    <Fragment>
      <Table bg="odd">
        <Table.Body>
          <Table.Row>
            <Table.Col as="th">Arrangör</Table.Col>
            <Table.Col>{competition.organizer}</Table.Col>
          </Table.Row>
          <Table.Row>
            <Table.Col as="th">Datum</Table.Col>
            <Table.Col>
              {competition.start_date === competition.end_date
                ? competition.start_date
                : `${competition.start_date} - ${competition.end_date}`}
            </Table.Col>
          </Table.Row>
          <Table.Row>
            <Table.Col as="th">Sista anmälningsdatum</Table.Col>
            <Table.Col>
              {competition.reg_deadline ? formatDate(new Date(competition.reg_deadline), 'yyyy-mm-dd') : '-'}
            </Table.Col>
          </Table.Row>
          <Table.Row>
            <Table.Col as="th">Status</Table.Col>
            <Table.Col>
              <CompetitionBadges competition={competition} inline />
            </Table.Col>
          </Table.Row>
          {competition.files.length > 0 && (
            <Table.Row>
              <Table.Col as="th">Dokument</Table.Col>
              <Table.Col>
                <ul style={{ listStyleType: 'none' }}>
                  {competition.files.map(file => (
                    <li key={file.id}>
                      <Link to={file.file} target="_blank">
                        {file.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </Table.Col>
            </Table.Row>
          )}
          {isOpen && (
            <Fragment>
              <Table.Row>
                <Table.Col as="th">Distrikt</Table.Col>
                <Table.Col>{competition.districts.map(d => d.name).join(', ')}</Table.Col>
              </Table.Row>
              <Table.Row>
                <Table.Col as="th">Plats</Table.Col>
                <Table.Col>{competition.location}</Table.Col>
              </Table.Row>
              <Table.Row>
                <Table.Col as="th">Kontaktperson</Table.Col>
                <Table.Col>
                  {competition.contact_first_name} {competition.contact_last_name}
                </Table.Col>
              </Table.Row>
              <Table.Row>
                <Table.Col as="th">Telefon</Table.Col>
                <Table.Col>
                  {competition.contact_phone ? (
                    <Link to={`tel:${competition.contact_phone}`}>{competition.contact_phone}</Link>
                  ) : (
                    '-'
                  )}
                </Table.Col>
              </Table.Row>
              <Table.Row>
                <Table.Col as="th">Email</Table.Col>
                <Table.Col>
                  {competition.contact_email ? (
                    <Link to={`mailto:${competition.contact_email}`}>{competition.contact_email}</Link>
                  ) : (
                    '-'
                  )}
                </Table.Col>
              </Table.Row>
              <Table.Row>
                <Table.Col as="th">Plusgiro/Bankgiro</Table.Col>
                <Table.Col>{competition.payment_info}</Table.Col>
              </Table.Row>
              {can('see-competition-api-key', competition.id) && (
                <Table.Row>
                  <Table.Col as="th">API-nyckel</Table.Col>
                  <Table.Col>{competition.api_key ? <SecretValue value={competition.api_key} /> : '-'}</Table.Col>
                </Table.Row>
              )}
            </Fragment>
          )}
        </Table.Body>
      </Table>

      <div style={{ textAlign: 'center', marginTop: 'var(--size-2)' }}>
        <ButtonLink onClick={toggle}>{isOpen ? 'Visa mindre' : 'Visa mer'}</ButtonLink>
      </div>
    </Fragment>
  );
}
